export enum NoteCategory {
    Client = 1,
    Staff = 2,
    Contact = 3
}